<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="code"
            :name="$t('fields.code').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.code"
            :counter="30"
            :label="$t('fields.code')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            vid="note"
            :name="$t('fields.note').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-textarea
            v-model="form.note"
            :label="$t('fields.note')"
            :hint="$t('fields.note')"
          ></v-textarea>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsCodesService } from '../../../utils/services/schoolsCodes.service';

  export default {
    name: 'SchoolCodeModal',
    data() {
      return {
        stored: null,
        form: {
          school_id: null,
          code: null,
          note: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchSchoolCode(schoolId, codeId) {
        return schoolsCodesService.get(schoolId, codeId)
        .then(response => {
            this.schoolCode = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored) {
        this.form.school_id = this.data.stored.school_id;
        if (this.data.stored.id) {
          await this.fetchSchoolCode(this.data.stored.school_id, this.data.stored.id);
          this.form.id = this.data.stored.id;
          this.form.code = this.schoolCode.name;
          this.form.note = this.schoolCode.note;
        }
      }
      this.loadingModal(false);
    },
  };
</script>
